import React from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PromptExplainer } from './components/PromptExplainer/PromptExplainer';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden text-plum" data-id="element-0" data-mp="2wjgp1comflds">
      <MetaPixel data-id="element-1" data-mp="2wi5lndz38fn7" />
      <OfferBar data-id="element-2" data-mp="28u5zkrcq1dey" />
      {/* Spacer matching the fixed offer bar height */}
      <div className="h-[58px] sm:h-[68px]" aria-hidden="true" style={{
      paddingBottom: "29px"
    }} data-id="element-3" data-mp="28s2xva27hvue" />
      <main data-id="element-4" data-mp="3ijxpcqos80jw">
        <Hero data-id="element-5" data-mp="3ik7eyd5x05p2" />
        <Stats data-id="element-6" data-mp="3ikr0s4yore8d" />
        <Testimonials data-id="element-7" data-mp="3ij652c0mxp8x" />
        <PainPoints data-id="element-8" data-mp="3ijpcuzwkmx98" />
        <Volumes data-id="element-9" data-mp="3ii4q3wgi0ilx" />
        <Bonuses data-id="element-10" data-mp="3mlat8v8bdto6" />
        <Pricing data-id="element-11" data-mp="3mkrgdsxitvh0" />
        <PromptExplainer data-id="element-12" data-mp="3mk83iqmq9x9u" />
        <FAQ data-id="element-13" data-mp="3mjg93j4va5l5" />
        <ValueStack data-id="element-14" data-mp="3rc9du70c5dx8" />
      </main>
      <Footer data-id="element-15" data-mp="3rbzngibdp4r0" />
    </div>;
}